module.exports = __webpack_public_path__ + "img/img_nav_person_hover.8f5bf352.svg";